module.exports = __webpack_public_path__ + "media/vid_top_case2.f51203f1.mp4";